import React, { useEffect, useState } from "react";
// Third party and libarries 
import { Card, Button, Row, Col, Form, Placeholder, InputGroup, Spinner } from "react-bootstrap";
import _ from "lodash";
// import moment from "moment";
import { useLazyQuery } from "@apollo/client";

// Components
import { covertTimeZone, NewCovertTimeZone, numberFormat } from "../../helper";
import CurrentDateComponents from "../../components/CurrentDateComponents";
import OrderStaffLists from "./ReportLists/OrderStaffLists";
import { GET_REPORT_ORDERS_STAFF_V2 } from "../../apollo/dashboard/query";
import PaginationHelper from "../../components/PaginationHelper";
// import { GET_STAFF_INFO } from "../../apollo/user/query";
import useWindowDimensions from "../../helper/windowDimensions";
import { MdDateRange, MdOutlineDateRange } from "react-icons/md";
import { FaSearch } from "react-icons/fa";
import { GET_CATEGORYS } from "../../apollo/category/query";
import styles from "./ReportStaffs.module.css";

export default function ReportOrderForStaff() {
    // States
    const user = JSON.parse(localStorage.getItem("USER_DATA")).data;
    const shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
    const [reportDatas, setReportDatas] = useState({
        total: 0,
        datas: [],
        report: {}
    });
    const [isCurrentModals, setIsCurrentModals] = useState(false);
    const [cdFillter, setCdFillter] = useState({
        createdAt_gte: "",
        createdAt_lt: "",
    });
    const [activeButton, setActiveButton] = useState("today");
    const [categories, setCategories] = useState([])
    const [categoriesPrepare, setCategoriesPrepare] = useState(null)
    const [invioceNo, setInvioceNo] = useState()
    const [distinguish, setDistinguish] = useState(false)

    const { _limit, _skip, Pagination_helper } = PaginationHelper();
    const { width } = useWindowDimensions()

    // GraphQL query
    const [getOrderAndReportStaffV2, { data: orderAndReportStaffV2, loading: loadingOrderReportV2 }] = useLazyQuery(GET_REPORT_ORDERS_STAFF_V2, {
        fetchPolicy: "cache-and-network",
    });

    const [loadCategoryData, { data: categoryData, loading: loadingLoadCategory }] = useLazyQuery(
        GET_CATEGORYS,
        { fetchPolicy: "cache-and-network" }
    );

    useEffect(() => {
        if (categoryData) setCategories(categoryData?.categories?.data);
    }, [categoryData]);

    useEffect(() => {
        if (orderAndReportStaffV2 && orderAndReportStaffV2?.ReportStaffsV2?.status) {
            const _newReportDatas = JSON.parse(orderAndReportStaffV2?.ReportStaffsV2?.msg);
            setReportDatas({
                total: orderAndReportStaffV2?.ReportStaffsV2?.total ?? 0,
                datas: _newReportDatas,
                report: orderAndReportStaffV2?.ReportStaffsV2?.reports ?? {}
            });
        }
    }, [orderAndReportStaffV2]);

    useEffect(() => {
        if (cdFillter?.createdAt_gte && cdFillter?.createdAt_lt && user) fetchDataReport();
        if (categories.length <= 0) factCategorys();
    }, [shopId, cdFillter?.createdAt_gte, cdFillter?.createdAt_lt,  _skip, invioceNo, categoriesPrepare, distinguish]);

    // get report data from ordergroup
    const fetchDataReport = async () => {
        try {
            if (loadingOrderReportV2) return;
            
            let _where = {
                shop: shopId,
                type: "POS",
                createBy: user?.id,
                isDeleted: false,
                distinguish: distinguish
            };

            if (cdFillter?.createdAt_gte && cdFillter?.createdAt_lt) {
                _where = {
                    ..._where,
                    createdAt_gte: NewCovertTimeZone(cdFillter?.createdAt_gte),
                    createdAt_lt: NewCovertTimeZone(cdFillter?.createdAt_lt)
                };
            }

            if(!_.isEmpty(invioceNo)) {
                _where = {
                    ..._where,
                    code: invioceNo
                }
            }
            if(!_.isEmpty(categoriesPrepare)) {
                _where = {
                    ..._where,
                    category: categoriesPrepare?.id,
                    categoryName: categoriesPrepare?.name
                }
            }

            await getOrderAndReportStaffV2({
                variables: {
                    where: _where,
                    skip: (_skip - 1) * _limit,
                    limit: _limit,
                },
            });
        } catch (error) {
            console.error(error);
        }
    };
    
    // get category data
    const factCategorys = async () => {
        let localData = JSON.parse(localStorage.getItem("SHOP_DATA"))
        if (loadingLoadCategory) return
        try {

            await loadCategoryData({
                variables: {
                    limit: null,
                    where: {
                        isDeleted: false,
                        orderBy: "createdAt_DESC",
                        shop: localData?.id,
                    },
                },
            });

        } catch (error) {
            console.log({ error })
        }
    }

    // handle change category
    const handleChangeCategory = (values) => {
        let _categoriesData = categories?.filter((category) => values?.includes(category?.id))
        setCategoriesPrepare(_categoriesData[0])
    }

    // on change invoice no
    const onChangeInvoiceNo = (e) => {
        const { value } = e.target;
        setInvioceNo(value);
        if (value === "") {
            setInvioceNo("");
        }
    };

    // prepare ordergrup and loading
    const initailDatas = {
        orderGroups: reportDatas?.datas,
        loadingOrderReportV2,
        orderAndReportStaffV2,
        _limit, _skip
    }

    return (
        <Card style={{ padding: width > 700 ? 20 : 5, border: "0" }}>
            <Card.Header>
                <Row>
                    <Col md="auto">
                        <Card.Title>ຍອດຂາຍພະນັກງານ</Card.Title>
                        <Card.Subtitle className="mb-2 text-muted">ລາຍາງນອໍເດີ້ຂອງພະນັກງານ ຕາມການແຕ່ລະບິນ</Card.Subtitle>
                    </Col>
                    <Col md="auto">
                        <Form.Check
                            type="checkbox"
                            id="distinguish-id"
                            label={
                                <span style={{ fontSize: 14, color: distinguish ? 'red' : 'black' }}>
                                    {distinguish ? 'ຈຳແນະອໍເດີຍ່ອຍ' : 'ບໍ່ຈຳແນະອໍເດີຍ່ອຍ'}
                                </span>
                            }
                            onChange={(e) => setDistinguish(e.target.checked)}
                            checked={distinguish}
                        />
                    </Col>
                </Row>
            </Card.Header> 
            <Row className="pt-2">
                <Col md={6}>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Label>ເລກທີ່ບິນ</Form.Label>
                        <InputGroup className="mb-3">
                            <InputGroup.Text id="basic-addon1"><FaSearch /></InputGroup.Text>
                            <Form.Control
                                placeholder="..."
                                aria-label="invoice_no"
                                aria-describedby="basic-addon1"
                                value={invioceNo}
                                onChange={(e) => onChangeInvoiceNo(e)}
                            />
                        </InputGroup>
                    </Form.Group>
                </Col>
                <Col md={3}>
                    <Form.Group>
                        <Form.Label>ປະເພດສິນຄ້າ</Form.Label>
                        <Form.Select onChange={(e) => handleChangeCategory(e?.target?.value)} aria-label="Default select example">
                            <option value="">--ເລືອກ--</option>
                            {categoryData && categories.map((option, _index) => (
                                <option key={_index} value={option?.id}>{option?.name}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Col>
                <Col md={3}>
                    <Form.Group className="mb-3 d-flex flex-column" controlId="exampleForm.ControlInput1">
                        <Form.Label>ວັນທີ, ເດືອນ, ປີ</Form.Label>
                        <Button
                            variant="outline-secondary"
                            onClick={() => setIsCurrentModals(true)}
                            style={{ width: "100%", maxWidth: 260, display: "flex", justifyContent: "start", gap: 5 }}
                        >
                            {/* <MdDateRange style={{ fontSize: 20 }} />
                            {!cdFillter.createdAt_gte || !cdFillter.createdAt_lt ? (
                                "mm/dd/yyyy"
                            ) : (
                                <>
                                    {covertTimeZone(cdFillter.createdAt_gte) +
                                        "-" +
                                        covertTimeZone(cdFillter.createdAt_lt)}
                                </>
                            )} */}
                            {(loadingOrderReportV2) ? (
                                <Spinner size="sm" />
                            ) : (
                                <MdOutlineDateRange className="icon" />
                            )}
                            <span className="date-text">
                                {!cdFillter ? "mm/dd/yyyy" : (
                                `${covertTimeZone(cdFillter?.createdAt_gte)} ຫາ ${covertTimeZone(cdFillter?.createdAt_lt)}`
                                )}
                            </span>
                        </Button>
                    </Form.Group>
                </Col>
            </Row>

            {loadingOrderReportV2 && !orderAndReportStaffV2 ? (
                <Row>
                    <Col md={8}>
                        <Placeholder as="p" animation="wave">
                            <Placeholder bg="light" style={{ height: 240, width: '100%' }} />
                        </Placeholder>
                    </Col>
                    <Col md={4}>
                        <Placeholder as="p" animation="wave">
                            <Placeholder bg="light" style={{ height: 240, width: '100%' }} />
                        </Placeholder>
                    </Col>
                </Row>
            ) : (
                <Row>
                    <Col md={8} className="mb-4">
                        <Card className={styles.staffCard}>
                            <Card.Header className="border-0 pb-0">
                                <div className={styles.sectionTitle}>
                                    <div className={styles.staffAvatar}>
                                        {user?.firstName ? user.firstName.charAt(0).toUpperCase() : "?"}
                                    </div>
                                    {user?.firstName ?? "ບໍ່ມີຂໍ້ມູນ"} {user?.lastName ?? ""}
                                </div>
                            </Card.Header>
                            <Card.Body className="pt-2">
                                <Row className="g-3">
                                    <Col sm={6}>
                                        <div className="d-flex align-items-center gap-2">
                                            <small className="text-muted">ເພດ:</small>
                                            <span>{user?.gender ?? "-"}</span>
                                        </div>
                                    </Col>
                                    <Col sm={6}>
                                        <div className="d-flex align-items-center gap-2">
                                            <small className="text-muted">ເບີໂທ:</small>
                                            <span>{user?.phone ?? "-"}</span>
                                        </div>
                                    </Col>
                                    <Col sm={6}>
                                        <div className="d-flex align-items-center gap-2">
                                            <small className="text-muted">ອີເມວ:</small>
                                            <span>{user?.email ?? "-"}</span>
                                        </div>
                                    </Col>
                                    <Col xs={12}>
                                        <div className="d-flex align-items-center gap-2">
                                            <small className="text-muted">ທີ່ຢູ່:</small>
                                            <span>{[user?.address?.village, user?.address?.district, user?.address?.province].filter(Boolean).join(", ") || "-"}</span>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={4} className="mb-4">
                        <Card className={styles.reportCard}>
                            <Card.Header className="border-0 pb-0">
                                <div className={styles.sectionTitle}>ສະຫຼູບຍອດຂາຍ</div>
                            </Card.Header>
                            <Card.Body className="pt-2">
                                <div className={styles.balanceRow}>
                                    <span className={styles.balanceLabel}>ທັງໝົດ ເງີນ/ອໍເດີ້</span>
                                    <span className={styles.balanceValue}>
                                        ₭{numberFormat(reportDatas?.report?.balanceSumPrice ?? 0)} / {reportDatas?.total ?? 0}
                                    </span>
                                </div>
                                <div className={styles.balanceRow}>
                                    <span className={styles.balanceLabel}>ເງິນກີບ</span>
                                    <span className={styles.balanceValue} style={{ color: reportDatas?.report?.balanceKip < 1 ? "#dc3545" : "#198754" }}>
                                        {numberFormat(reportDatas?.report?.balanceKip ?? 0)} ₭
                                    </span>
                                </div>
                                <div className={styles.balanceRow}>
                                    <span className={styles.balanceLabel}>ເງິນບາດ</span>
                                    <span className={styles.balanceValue} style={{ color: reportDatas?.report?.balanceBaht < 1 ? "#dc3545" : "#198754" }}>
                                        {numberFormat(reportDatas?.report?.balanceBaht ?? 0)} ฿
                                    </span>
                                </div>
                                <div className={styles.balanceRow}>
                                    <span className={styles.balanceLabel}>ເງິນໂດລາ</span>
                                    <span className={styles.balanceValue} style={{ color: reportDatas?.report?.balanceUsd < 1 ? "#dc3545" : "#198754" }}>
                                        {numberFormat(reportDatas?.report?.balanceUsd ?? 0)} $
                                    </span>
                                </div>
                                <div className={styles.balanceRow}>
                                    <span className={styles.balanceLabel}>ເງິນໂອນ</span>
                                    <span className={styles.balanceValue} style={{ color: reportDatas?.report?.totalTransfer < 1 ? "#dc3545" : "#198754" }}>
                                        ₭{numberFormat(reportDatas?.report?.totalTransfer ?? 0)}
                                    </span>
                                </div>
                                <div className={styles.balanceRow}>
                                    <span className={styles.balanceLabel}>ເງິນສົດ</span>
                                    <span className={styles.balanceValue} style={{ color: reportDatas?.report?.totalCash < 1 ? "#dc3545" : "#198754" }}>
                                        ₭{numberFormat(reportDatas?.report?.totalCash ?? 0)}
                                    </span>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>

                </Row>
            )}

            <OrderStaffLists initailDatas={initailDatas} distinguish={distinguish} />
            {(loadingOrderReportV2 && !orderAndReportStaffV2) ? "" :
                <div style={{ display: "flex", justifyContent: 'end' }}>
                    {Pagination_helper(reportDatas?.total, "", ``)}
                </div>
            }

            <CurrentDateComponents
                onCloseModal={() => setIsCurrentModals(false)}
                openModal={isCurrentModals}
                setCdFillter={setCdFillter}
                setActiveButton={setActiveButton}
                activeButton={activeButton}
            />
        </Card>
    );
}
